import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type AnnotationType = 'bounding_box' | 'dot' | 'polygon' | 'line' | 'crosshair'

type Annotation = {
  annotation_id: string
  area?: number
  colorIndex?: number
  engagement_level?: boolean
  image_id?: string
  image_idx?: number
  label: string
  'sparkai.id'?: string
  sublabels?: [] | string[]
  type: AnnotationType
  vertices: {
    x: number
    y: number
  }[]
  original_annotation_id?: string
}

type Task = {
  task_id: string
  operator_task_review_id?: string
  date_created: string
  date_closed?: string
  time_to_assign?: number
  time_to_close?: number
  time_to_resolution?: number
  task_score?: number
  annotations?: Annotation[]
  state: 'closed' | 'open' | 'in-progress' | 'discarded'
  resolution_id?: string
  resolution?: {
    resolution_id: string
    response: string
    answers?: string[]
    annotations?: Annotation[]
    originalAnnotations?: Annotation[]
    images?: { location: string }[]
    subrequests?: {
      answers: string[]
      question: string[]
    }[]
  }
  images?: { location: string }[]
  operator?: {
    name: string
    email: string
    avatar_url?: string
    app_user_id: string
  }
}

export function useGetByEngagementId(id?: string) {
  return useQuery<Task[]>({
    queryKey: ['tasksByEngagement', id],
    queryFn: async () => {
      const { data } = await apiClient.get<Task[]>(`/int/task`, {
        params: { engagement_id: id },
      })
      return data
    },
    enabled: Boolean(id),
  })
}
